import React, { BaseSyntheticEvent, useContext, useState } from 'react';
import { deleteDevice, Devices } from '../../api/studykit';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@dls/react-core';
import { StudyPageContext } from '../../App';
import { KeyedMutator } from 'swr/dist/types';
import { useSnackbar } from 'notistack';
import { NotiStackAction } from '../styled/notistack-action';
import {
  StyledDialogHeading,
  StyledDialogIconContainer,
  StyledDialogTitleForIcon,
} from '../styled/styles';
import { Icon } from '@dls/react-icon';
import { ColorX11 } from '../../styling/color';

interface RemoveDeviceDialogProps {
  subjectId: string;
  device: Devices;
  open: boolean;
  onClose: () => void;
  mutate: KeyedMutator<any>;
}

export const RemoveDeviceDialog: React.FC<RemoveDeviceDialogProps> = ({
  subjectId,
  device,
  open,
  onClose,
  mutate,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { study } = useContext(StudyPageContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit = (e: BaseSyntheticEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    deleteDevice(study.id, subjectId, device.id)
      .then(() => mutate())
      .then(() => {
        enqueueSnackbar(`${device.name} successfully deleted!`, {
          variant: 'success',
          action: <NotiStackAction close={closeSnackbar} />,
        });
      })
      .catch(console.error)
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <StyledDialogTitleForIcon disableTypography>
        <StyledDialogIconContainer>
          <Icon name={'DeleteTrash'} size={'m'} color={ColorX11.Black} />
        </StyledDialogIconContainer>
        <StyledDialogHeading variant={'h3'}>Are you sure?</StyledDialogHeading>
      </StyledDialogTitleForIcon>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove the following device?
          <br /> <br />
          {device.name}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <form onSubmit={onSubmit}>
          <Button
            disabled={isSubmitting}
            type={'button'}
            onClick={onClose}
            dls_variant={'quietEmphasis'}
          >
            Cancel
          </Button>
          <Button
            disabled={isSubmitting}
            style={{ marginLeft: `8px` }}
            type={'submit'}
            dls_variant={'signalError'}
          >
            Delete
          </Button>
        </form>
      </DialogActions>
    </Dialog>
  );
};
